/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();




// custom product options tooltip starts

// document.querySelectorAll('.custom-dropdown').forEach(dropdown => {
//   const tooltipContainer = dropdown.querySelector('.js-custom-tooltip');
//   let hideTimeout;

//   dropdown.querySelectorAll('.trgier').forEach(option => {
//     option.addEventListener('mouseenter', function () {
//       clearTimeout(hideTimeout);

//       const tooltip = this.parentElement.querySelector('.custom-tooltip');
//       if (!tooltip) return;

//       const tooltipClone = tooltip.cloneNode(true);
//       tooltipClone.style.display = 'block';

//       tooltipContainer.innerHTML = '';
//       tooltipContainer.appendChild(tooltipClone);
//       tooltipContainer.style.display = 'block';

//       const optionRect = this.parentElement.getBoundingClientRect();
//       const dropdownRect = dropdown.getBoundingClientRect();

//       tooltipContainer.style.position = 'absolute';
//       tooltipContainer.style.top = `${optionRect.top - dropdownRect.top}px`;
//       tooltipContainer.style.left = `${optionRect.right - dropdownRect.left + 10}px`;
//       tooltipContainer.style.zIndex = '9999';
//     });
//   });

//   dropdown.querySelectorAll('.info').forEach(option => {
//     option.addEventListener('click', function () {
//       clearTimeout(hideTimeout);

//       const tooltip = this.parentElement.querySelector('.custom-tooltip');
//       if (!tooltip) return;

//       const tooltipClone = tooltip.cloneNode(true);
//       tooltipClone.style.display = 'block';

//       tooltipContainer.innerHTML = '';
//       tooltipContainer.appendChild(tooltipClone);
//       tooltipContainer.style.display = 'block';

//       // Rebind close button after appending
//       const closeBtn = tooltipContainer.querySelector('.custom-tooltip-close');
//       if (closeBtn) {
//         closeBtn.addEventListener('click', () => {
//           hideTimeout = setTimeout(() => {
//             tooltipContainer.style.display = 'none';
//             tooltipContainer.innerHTML = '';
//           }, 100);
//         });
//       }

//       const optionRect = this.parentElement.getBoundingClientRect();
//       const dropdownRect = dropdown.getBoundingClientRect();

//       tooltipContainer.style.position = 'absolute';
//       tooltipContainer.style.top = `${optionRect.top - dropdownRect.top}px`;
//       tooltipContainer.style.left = `${optionRect.right - dropdownRect.left + 10}px`;
//       tooltipContainer.style.zIndex = '9999';
//     });
//   });

//   // Handle mouse leaving the entire dropdown (including tooltip)
//   dropdown.addEventListener('mouseleave', () => {
//     if(window.innerWidth > 990){
//       hideTimeout = setTimeout(() => {
//         tooltipContainer.style.display = 'none';
//         tooltipContainer.innerHTML = '';
//       }, 100);
//     }
//   });

//   // Prevent tooltip from hiding if mouse enters it
//   tooltipContainer.addEventListener('mouseenter', () => {
//     clearTimeout(hideTimeout);
//   });

//   tooltipContainer.addEventListener('mouseleave', () => {
//     tooltipContainer.style.display = 'none';
//     tooltipContainer.innerHTML = '';
//   });
// });

document.querySelectorAll('.custom-dropdown').forEach(dropdown => {
  const tooltipContainer = dropdown.querySelector('.js-custom-tooltip');
  let hideTimeout;

  const isDesktop = () => window.innerWidth > 990;

  // Desktop only: show tooltip on hover of .trgier
  if (isDesktop()) {
    
    dropdown.querySelectorAll('.trgier').forEach(option => {
      option.addEventListener('mouseenter', function () {
        clearTimeout(hideTimeout);
        const tooltip = this.parentElement.querySelector('.custom-tooltip');
        if (!tooltip) return;

        const tooltipClone = tooltip.cloneNode(true);
        tooltipClone.style.display = 'block';

        tooltipContainer.innerHTML = '';
        tooltipContainer.appendChild(tooltipClone);
        tooltipContainer.style.display = 'block';

        // Get the screen height
        const screenHeight = window.innerHeight;
        
        // Calculate vertical center
        const tooltipHeight = tooltipContainer.offsetHeight;
        const centerY = (screenHeight - tooltipHeight) / 2; // Vertically center

        // Set the tooltip's position at 40% from the left
        tooltipContainer.style.position = 'fixed';
        tooltipContainer.style.top = `${centerY}px`; // Vertically centered
        tooltipContainer.style.left = '31%'; // Positioned at 40% from the left
        tooltipContainer.style.zIndex = '9999';
      });
      document.querySelectorAll('.js-custom-tooltip').forEach(function(el) {
  el.addEventListener('mouseenter', function() {
    document.body.classList.add('tooltip-active');
  });
  el.addEventListener('mouseleave', function() {
    document.body.classList.remove('tooltip-active');
  });
});

    });
  }

  // Click handler (active on both desktop and mobile) for .info
  dropdown.querySelectorAll('.info').forEach(option => {
    option.addEventListener('click', function (e) {
      e.stopPropagation();
      clearTimeout(hideTimeout);

      const tooltip = this.parentElement.querySelector('.custom-tooltip');
      if (!tooltip) return;

      const tooltipClone = tooltip.cloneNode(true);
      tooltipClone.style.display = 'block';

      tooltipContainer.innerHTML = '';
      tooltipContainer.appendChild(tooltipClone);
      tooltipContainer.style.display = 'block';

      const closeBtn = tooltipContainer.querySelector('.custom-tooltip-close');
      if (closeBtn) {
        closeBtn.addEventListener('click', () => {
          hideTimeout = setTimeout(() => {
            tooltipContainer.style.display = 'none';
            tooltipContainer.innerHTML = '';
          }, 100);
        });
      }

      // Get the screen height for vertical centering
      const screenHeight = window.innerHeight;
      const tooltipHeight = tooltipContainer.offsetHeight;
      const centerY = (screenHeight - tooltipHeight) / 2;

      // Set the tooltip's position at 40% from the left
      tooltipContainer.style.position = 'fixed';
      tooltipContainer.style.top = `${centerY}px`;
      tooltipContainer.style.left = '31%'; // Positioned at 40% from the left
      tooltipContainer.style.zIndex = '9999';
    });
  });

  // Handle mouse leaving the dropdown (desktop only)
  if (isDesktop()) {
    dropdown.addEventListener('mouseleave', () => {
      hideTimeout = setTimeout(() => {
        tooltipContainer.style.display = 'none';
        tooltipContainer.innerHTML = '';
      }, 100);
      
    });

    tooltipContainer.addEventListener('mouseenter', () => {
      clearTimeout(hideTimeout);
    });

    tooltipContainer.addEventListener('mouseleave', () => {
      tooltipContainer.style.display = 'none';
      tooltipContainer.innerHTML = '';
    });
  }
});








// custom product options tooltip starts


